namespace $ {

	type $shm_dashboard_data_filter_timing = {
		time: number
	}

	const $shm_dashboard_data_filter_timings = new WeakMap< $shm_dashboard_data, $shm_dashboard_data_filter_timing >()

	export class $shm_dashboard_data extends $shm_ba_data {

		@ $mol_mem
		filter_table() {
			if( !$shm_dashboard_data_filter_timings.has( this ) ) {
				$shm_dashboard_data_filter_timings.set( this, {
					time: $mol_dom_context.performance.now(),
				} )
			}

			return $mol_error_fence(
				()=> super.filter_table(),
				error => {
					$shm_dashboard_data_filter_timings.delete( this )
					return $mol_fail( error )
				},
			)
		}

		query_posts_ready( limit: number | null, offset: number ): $shm_ba_data_table {
			const table = super.query_posts_ready( limit, offset )
			const started_at = $shm_dashboard_data_filter_timings.get( this )

			if( started_at ) {
				$shm_dashboard_data_filter_timings.delete( this )
				console.log(
					'Итоговое время фильтров и загрузки ленты сообщений:',
					`${ ( $mol_dom_context.performance.now() - started_at.time ).toFixed( 1 ) } мс`,
				)
			}

			return table
		}

	}

}
